import React, { useState } from "react";

import {
  ActionIcon,
  Flex,
  Menu,
  Table,
  Text,
  Title,
  UnstyledButton,
} from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
// import useStyles from "./stylesComponents";
import moment from "moment";
import { useDisclosure } from "@mantine/hooks";
// import CreateStaffFolderModal from "./CreateStaffFolderModal";
import { IconEdit } from "@tabler/icons-react";
import { deleteFolder } from "../../services/Document";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import RecordNotFound from "../RecordNotFound";
import StaffDeleteFileModal from "./StaffDeleteFileModal";
import CreateStaffFolderModal from "./CreateStaffFolderModal";
import StaffDeleteFolderModal from "./StaffDeleteFolderModal";
import useStyles from "./style";
import FolderSvg from "../Svgs/FolderSvg";
// import DeleteFolderModal from "../Document/DeleteFolderModal";
// import DeleteFolderModal from "./DeleteFolderModal";

const StaffFolderItem = ({
  data,
  setSelectedFolder,
  setType,
  userId,
  userType,
}) => {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);

  return (
    <div key={data?._id} className={classes.folderItem}>
      <div className={classes.verticalIconContainer}>
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <UnstyledButton data-testid="folder-menu">
              <IconDotsVertical
                size={20}
                color="#737373"
                style={{ cursor: "pointer" }}
              />
            </UnstyledButton>
          </Menu.Target>

          <Menu.Dropdown>
            {/* <Menu.Label>Application</Menu.Label> */}
            <Menu.Item
              onClick={() => {
                setType("file");
                setSelectedFolder(data);
              }}
              icon={
                <img
                  src="/assets/images/open.png"
                  alt="open"
                  className={classes.folderMenuIcon}
                />
              }
            >
              Open
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                const zip = new JSZip();
                let func = (url) => {
                  return new Promise(function (resolve, reject) {
                    JSZipUtils.getBinaryContent(url, function (err, data) {
                      if (err) {
                        reject(err);
                      } else {
                        resolve(data);
                      }
                    });
                  });
                };
                data?.files?.map((item) => {
                  zip.file(
                    `${item?.name}.${
                      item?.fileUrl?.split(".")[
                        item?.fileUrl?.split(".")?.length - 1
                      ]
                    }`,
                    func(item?.fileUrl),
                    { binary: true },
                  );
                });
                zip.generateAsync({ type: "blob" }).then(function (content) {
                  saveAs(content, data?.name);
                });
              }}
              icon={
                <img
                  src="/assets/images/downloadFolder.png"
                  alt="download"
                  className={classes.folderMenuIcon}
                />
              }
            >
              Download
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                open();
              }}
              icon={
                <img
                  src="/assets/images/editFolder.png"
                  alt="rename"
                  className={classes.folderMenuIcon}
                />
              }
            >
              Rename
            </Menu.Item>
            <Menu.Item
              icon={
                <img
                  src="/assets/images/deleteFolder.png"
                  alt="delete"
                  className={classes.folderMenuIcon}
                  style={{ width: 25, margin: 0 }}
                />
              }
              style={{ color: "red" }}
              onClick={async () => {
                deleteOpen();
                // await deleteFolder(data?._id);
              }}
            >
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
      <div
        className={classes.column}
        onClick={() => {
          setType("file");
          setSelectedFolder(data);
        }}
      >
        <FolderSvg />
        {/* 
        <img
          src="/assets/images/folderBig.png"
          alt="folder-icon"
          className={classes.folderBig}
          onClick={() => {
            setType("file");
            setSelectedFolder(data);
          }}
        /> */}
      </div>
      <Flex justify={"center"} direction={"column"} align={"center"}>
        <Title
          onClick={() => {
            setType("file");
            setSelectedFolder(data);
          }}
          order={5}
        >
          {data?.name}
        </Title>
        <Text
          onClick={() => {
            setType("file");
            setSelectedFolder(data);
          }}
          className={classes.folderDateText}
          fz="xs"
        >
          {moment(data?.createdAt).format("MMMM DD, YYYY")}
        </Text>
      </Flex>

      <CreateStaffFolderModal
        opened={opened}
        onclose={() => {
          close();
        }}
        title={"Rename Folder"}
        data={data}
        userId={userId}
        userType={userType}
      />
      <StaffDeleteFolderModal
        opened={Deleteopened}
        onclose={() => {
          deleteClose();
        }}
        title={"Delete Folder"}
        data={data}
        userId={userId}
        userType={userType}
      />
    </div>
  );
};

const StaffFolderTable = ({
  folders,
  setType,
  setSelectedFolder,
  filteredFolders,
  userId,
  userType,
}) => {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);
  const [selectedFolderForAction, setSelectedFolderForAction] = useState(null);

  const ths = (
    <tr>
      <th style={{ width: "50%" }}>Name</th>
      <th style={{ width: "30%" }}>Date</th>
      <th style={{ width: "20%" }}>Actions</th>
    </tr>
  );
  return (
    <>
      {filteredFolders?.length > 0 ? (
        <Table striped fontSize={"md"}>
          <thead>{ths}</thead>
          <tbody>
            {filteredFolders
              // ?.filter((item) => item?.staff === staff)
              ?.map((val, index) => (
                <>
                  <tr key={val?._id}>
                    <td>
                      <div className={classes.imgName}>
                        <FolderSvg size={20} /> <p>{val?.name}</p>
                        <ActionIcon
                          color="yellow"
                          variant="light"
                          onClick={(e) => {
                            setSelectedFolderForAction(val);
                            open(e);
                          }}
                        >
                          <IconEdit />
                        </ActionIcon>
                      </div>
                    </td>
                    <td>{`${moment(val?.createdAt).format("MM/DD/YYYY")}`}</td>
                    {/* <td>{val?.location}</td> */}
                    <td>
                      <div
                        className={classes.row}
                        style={{ gap: 15, width: "fit-content" }}
                      >
                        <img
                          onClick={() => {
                            setType("file");
                            setSelectedFolder(val);
                          }}
                          src="/assets/images/eye.png"
                          alt="view"
                          style={{ width: 30, cursor: "pointer" }}
                        />
                        <img
                          onClick={() => {
                            const zip = new JSZip();
                            let func = (url) => {
                              return new Promise(function (resolve, reject) {
                                JSZipUtils.getBinaryContent(
                                  url,
                                  function (err, data) {
                                    if (err) {
                                      reject(err);
                                    } else {
                                      resolve(data);
                                    }
                                  },
                                );
                              });
                            };
                            val?.files?.map((item) => {
                              zip.file(
                                `${item?.name}.${
                                  item?.fileUrl?.split(".")[
                                    item?.fileUrl?.split(".")?.length - 1
                                  ]
                                }`,
                                func(item?.fileUrl),
                                {
                                  binary: true,
                                },
                              );
                            });
                            zip
                              .generateAsync({ type: "blob" })
                              .then(function (content) {
                                saveAs(content, val?.name);
                              });
                          }}
                          src="/assets/images/downloadFile.png"
                          alt="download"
                          className={classes.actionsImageRow}
                        />
                        <img
                          onClick={async () => {
                            setSelectedFolderForAction(val);
                            deleteOpen();
                            // await deleteFolder(val?._id);
                          }}
                          src="/assets/images/deleteFolder.png"
                          alt="delete"
                          style={{ width: 30, cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                </>
              ))}
          </tbody>
        </Table>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: "60vh",
            gap: "8rem",
          }}
        >
          <RecordNotFound />
          <p className={classes.notFoundText}>
            You don&apos;t have any files uploaded to this folder, click on
            "upload documents" to add.
          </p>
        </div>
      )}
      <CreateStaffFolderModal
        opened={opened}
        onclose={() => {
          close();
        }}
        title={"Rename Folder"}
        data={selectedFolderForAction}
        userId={userId}
        userType={userType}
      />
      <StaffDeleteFolderModal
        opened={Deleteopened}
        onclose={() => {
          deleteClose();
        }}
        title={"Delete Folder"}
        data={selectedFolderForAction}
        userId={userId}
        userType={userType}
      />
    </>
  );
};

export { StaffFolderItem, StaffFolderTable };
